import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    document.getElementById('contact-form')?.addEventListener('submit', function (event) {
      event.preventDefault();
      
      const form = event.target as HTMLFormElement;
      const formData = new FormData(form);
  
      fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          body: formData,
      })
      .then(response => response.json())
      .then(data => {
          if (data.success) {
              document.getElementById('success')!.style.display = 'block';
              form.reset();
          } else {
              document.getElementById('result')!.textContent = 'Error sending message';
          }
      })
      .catch(error => {
          document.getElementById('result')!.textContent = 'Failed to send message';
      });
  });
  }

  

}
